export const hero = {
  title: "Welcome to Access Crewing Services",
  subtitle: "Your Fractional Crewing Provider.",
  body: "From initial project planning to final execution, we’re here to guide you in your crewing and logistics needs every step of the way.",
  ctas: [{ text: "Find Out More Today", url: "/contact" }],
};

export const services = {
  title: "Our Services",
  content: [
    {
      title: "Fractional Crewing Solutions",
      body: [
        "On-demand recruitment of skilled offshore professionals.",
        "Flexible, project-based crewing for short or long-term needs.",
        "Crew retention strategies to minimise turnover.",
      ],
    },
    {
      title: "Compliance & Documentation",
      body: [
        "End-to-end management of personnel documentation, visas, and work permits.",
        "Standardised compliance checks and audit-ready processes.",
        "Support for ensuring regulatory adherence across jurisdictions.",
      ],
    },
    {
      title: "Training & Development",
      body: [
        "Coordinated case-specific training packages focussing on compliance, safety, and upskilling.",
        "Professional Development Management opportunities.",
        "Partnerships with trusted training providers.",
      ],
    },
    {
      title: "Logistics Coordination",
      body: [
        "Centralised crew travel and accommodation planning.",
        "Coordination of schedules to align with project timelines.",
        "Cost-effective solutions for complex offshore operations.",
      ],
    },
  ],
  cta: { text: "Explore Our Solutions", url: "/services" },
};

export const customerTestimonials = {
  title: "Trusted by Companies and Professionals Worldwide",
  body: "Access CV has been a game-changer for our offshore operations. Their expertise in compliance and crewing allowed us to focus on delivering results while they handled the logistics seamlessly. Highly recommended!",
  footer:
    "Join the many companies and professionals who trust Access Crewing Solutions for their offshore crewing and logistics needs.",
};
export const closing = {
  title: "Start Your Journey Today",
  body: "Contact us today to learn how our Fractional Crewing and Logistics Services can streamline your projects and enhance your workforce.",
  ctas: [{ text: "Contact Us Now", url: "/contact" }],
};
